/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * <p>
 * Copyright © 2019 Pearson Education, Inc.
 * All Rights Reserved.
 * <p>
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained from Pearson Education, Inc.
 *
 * This is the data class for holding partner attributes.
 *
 * @author urahish
 * 02/07/2022
 *
 */

import React, {useEffect, useState} from 'react';
import '../../../modals/modalView.css';
import DatePicker from 'react-datepicker';

import 'react-datepicker/dist/react-datepicker.css';

/**
 * functional component for the DateTimePicker
 * @param inputType
 * @param labelName
 * @param handleChange
 * @returns {*}
 * @constructor
 */
const DateTimePicker = ({labelName, optionValueName, handleChange, valueType, syncInitialValue = true}) => {
    const [startDate, setStartDate] = useState(new Date(new Date().setHours(0,0,0,0)));
    const [endDate, setEndDate] = useState(new Date(new Date().setHours(23,59,59,999)));

    useEffect(() => {
        if (!syncInitialValue) {
            return;
        }
        if (valueType === 'endDate') {
            let formattedDate = formatDate(endDate)
            handleChange({
                optionValueName: optionValueName,
                optionLabelName: optionValueName,
                label: formattedDate,
                value: formattedDate
            });
        } else {
            let formattedDate = formatDate(startDate)
            handleChange({
                optionValueName: optionValueName,
                optionLabelName: optionValueName,
                label: formattedDate,
                value: formattedDate
            });
        }
    }, []);

    const handleStartDate = (date) => {
        let formattedDate = formatDate(date)
        setStartDate(date);
        handleChange({
            optionValueName: optionValueName,
            optionLabelName: optionValueName,
            label: formattedDate,
            value: formattedDate
        });
    }

    const handleEndDate = (date) => {
        let formattedDate = formatDate(date)
        setEndDate(date);
        handleChange({
            optionValueName: optionValueName,
            optionLabelName: optionValueName,
            label: formattedDate,
            value: formattedDate
        });
    }

    const formatDate = (d) => {
        if (d !== null) {
            let currentMonth = d.getMonth() + 1;
            currentMonth = ("0" + currentMonth).slice(-2);
            let currentDate = d.getDate();
            currentDate = ("0" + currentDate).slice(-2);
            let currentHours = d.getHours();
            currentHours = ("0" + currentHours).slice(-2);
            let currentMinutes = d.getMinutes();
            currentMinutes = ("0" + currentMinutes).slice(-2);

            return d.getFullYear() + '-' + currentMonth + '-' + currentDate + '%20' + currentHours + ':' + currentMinutes;
        }
    }

    let input = null;
    if (valueType === 'endDate') {
        input =
            <DatePicker
                selected={endDate}
                onChange={(date) => handleEndDate(date)}
                showTimeSelect
                timeFormat="HH:mm"
                timeIntervals={15}
                dateFormat="MMMM d, yyyy h:mm aa"
                showWeeks={false}
                fixedHeight={true}
            />;
    } else {
        input =
            <DatePicker
                selected={startDate}
                onChange={(date) => handleStartDate(date)}
                showTimeSelect
                timeFormat="HH:mm"
                timeIntervals={15}
                dateFormat="MMMM d, yyyy h:mm aa"
                showWeeks={false}
                fixedHeight={true}
            />;
    }



    return(
        <div>
            <label>
                {labelName}
            </label>
            {input}
        </div>
    );
};

export default DateTimePicker;
